import { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

interface MSTeamsNoChannelsIconProps extends SvgIconProps { }

const MSTeamsNoChannelsIcon: FunctionComponent<MSTeamsNoChannelsIconProps> = (props) => {
	return (
		<svg
			fill="none"
			height="72"
			viewBox="0 0 72 72"
			width="72"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				fill="white"
				height="72"
				width="72"
			/>
			<path d="M30 3H6C4.3425 3 3 4.3425 3 6V33L9 27H30C31.6575 27 33 25.6575 33 24V6C33 4.3425 31.6575 3 30 3Z" fill="#F5F6FA" />
			<path d="M42 39H66C67.6575 39 68.985 40.3425 68.985 42L69 69L63 63H42C40.3425 63 39 61.6575 39 60V42C39 40.3425 40.3425 39 42 39ZM58.5 52.5H61.5V49.5H58.5V52.5ZM52.5 52.5H55.5V49.5H52.5V52.5ZM46.5 52.5H49.5V49.5H46.5V52.5Z" fill="#E4E8F0" />
		</svg>
	);
};

export default MSTeamsNoChannelsIcon;